import React from "react";
import { QuickFilter } from "../../../components";
import { Button, Icon } from "../../../components/ui";
import { ContactTable } from "../../../views/Users/index.jsx";
import { useStoreWriteGuard } from "../../../helpers/storeScope";

const SearchIcon = () => (
  <svg
    className="assign-client-picker__search-icon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
  >
    <circle cx="7" cy="7" r="4.5" stroke="currentColor" strokeWidth="1.4" />
    <path
      d="M10.5 10.5L14 14"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

/**
 * Client search + create + list picker used by Assign Client in Order / Sell / PX flows.
 * Mobile layout is styled via assign-client.scss; desktop keeps the table picker.
 */
export function AssignClientPicker({
  onSearchChange,
  onCreateClick,
  onSelectClient,
  searchQuery,
  selectedContactId,
}) {
  const { blocked: storeGuardBlocked, reason: storeGuardReason } = useStoreWriteGuard();

  return (
    <div className="assign-client-picker">
      <div className="assign-client-picker__search-wrap">
        <SearchIcon />
        <QuickFilter
          className="assign-client-picker__search contacts"
          placeholder="Quick search for clients"
          onUpdate={onSearchChange}
        />
      </div>

      {/* A client record is store-owned; from "Master Store" there is no single
          store to create it in. See useStoreWriteGuard. */}
      <Button
        variant="secondary"
        className="assign-client-picker__create create"
        onClick={onCreateClick}
        disabled={storeGuardBlocked}
        title={storeGuardReason}
        leadingIcon={<Icon name="Plus" size="sm" className="assign-client-picker__create-icon" />}
      >
        Create a new client
      </Button>

      <div className="assign-client-picker__list">
        <div className="assign-client-picker__list-label">Client list</div>
        <ContactTable
          className="assign-client-picker__table mt"
          onSelectClick={onSelectClient}
          searchQuery={searchQuery}
          selectedContactId={selectedContactId}
          minSearchLength={3}
          pickerLayout="horizontal"
        />
      </div>
    </div>
  );
}
